import { CustomContentsServant } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { IContentTileActionObj, IContentTileIconObj, IContentTileTextObj } from 'ui-ng-content-tile';

interface IAppointmentSchedulingSetupObj {
  icon: IContentTileIconObj;
  text: IContentTileTextObj;
  action: IContentTileActionObj;
}

export class ScheduleAppointmentCardComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-schedule-appointment-card/src/components/schedule_appointment_card.html';
  public controller: any = 'ScheduleAppointmentCardController';
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    buttonText: '@',
    showPrefixText: '@'
  };
}

export class ScheduleAppointmentCardController {
  private buttonText: string;
  private showPrefixText: string;
  private isAppointmentsFeatureEnabled: string;
  private appointmentCardConfig: IAppointmentSchedulingSetupObj;
  private scheduleAppointmentLabel: string = 'Schedule an Appointment';

  constructor(
    private $state: ng.ui.IStateService,
    private appConfigModel: any,
    private FEATURE_APPOINTMENTS: string,
    private ngCustomContentsServant: CustomContentsServant
  ) {
    const appointmentLabel = !_4.isEmpty(this.appConfigModel.getConfigProperty('advisor_label'))
      ? this.appConfigModel.getConfigProperty('advisor_label')
      : this.appConfigModel.getConfigProperty('cat-advisor_label');
    this.buttonText = this.buttonText || 'Schedule an Appointment';
    this.isAppointmentsFeatureEnabled = appConfigModel.isFeatureEnabled(FEATURE_APPOINTMENTS);
    this.ngCustomContentsServant.getButtonLabel(this.scheduleAppointmentLabel).then((label: string) => {
      this.scheduleAppointmentLabel = label;
      this.appointmentCardConfig = {
        icon: {
          type: 'user',
          theme: 'magenta'
        },
        text: {
          title: 'Any questions?',
          subTitle: this.scheduleAppointmentLabel
        },
        action: {
          state: 'my.appointments',
          params: {},
          href: '#/my/host/as3/appointment-new'
        }
      };
    });
  }

  isFixed(): boolean {
    return !(_4.isEmpty(this.showPrefixText) || this.showPrefixText === 'true');
  }

  gotoAppointment(): void {
    window.location.assign('#/my/host/as3/appointment-new');
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-schedule-appointment-card/src/components/schedule_appointment_card.ts